module.exports = {
  ConfigureDisplayColumns: 'Configure display columns',
  AllNames: 'All names',
  SelectedColumns: 'Selected columns',
  YouToViewSecondaryInformation: 'You don\'t have permission to view secondary table information!',
  Yes: 'yes',
  WorkflowNumber: 'Job Number',
  YouToSetSecondaryColumns: 'You don\'t have permission to set secondary table display columns!',
  CancelCounting: 'カウントをキャンセルする'
}
